import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field } from 'redux-form';
import { Container, Button, Form } from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import Logger from 'util/Logger';
import { Band } from 'components/layout';
import LocationDetailsSection from './LocationDetailsSection';
import { preventEnterSubmit } from 'actions/formActions';

const LocationForm = ({ handleSubmit, isSubmitting }) => {
  const areas = useSelector((state) => state.referenceData.areas);
  
  return (
    <Form onSubmit={handleSubmit} onKeyPress={preventEnterSubmit}>
      <Band tint>
        <LocationDetailsSection areas={areas} />
      </Band>
      <Container>
        <Button color="primary" className="btn-save" disabled={isSubmitting}>
          Save
        </Button>
      </Container>
    </Form>
  );
};

LocationForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

const enhance = reduxForm({
  form: 'locationForm',
  enableReinitialize: true,
  onSubmitFail: (errors) => {
    Logger.error(
      'We were unable to save the changes, please review the fields in red and try again.',
      errors,
      'Location not saved'
    );
  },
});

export default enhance(LocationForm);
